import app from '../../app/store'

import User from './user'

import Socket from './socket'

import Session from './session'

import Rules from './rules'

import Kb from './kb'

import Button from './button'

import Ui from './ui'

import ProactiveMessages from './proactive-messages'

export default {
  ...app,
  User,
  Socket,
  Session,
  Rules,
  Kb,
  Button,
  Ui,
  ProactiveMessages
}
